import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'hubs.admissions.recommended-courses.title',
    defaultMessage: `Recommended Courses`,
  },
  subtitle: {
    id: 'hubs.admissions.recommended-courses.subtitle',
    defaultMessage: `Taking these courses can help prepare you to be succcessful at {collegeName}.`,
  },
  columnName: {
    id: 'hubs.admissions.recommended-courses.columnName',
    defaultMessage: `Course Name`,
  },
  columnYearsRequired: {
    id: 'hubs.admissions.recommended-courses.columnYearsRequired',
    defaultMessage: `Years Required`,
  },
  columnYearsRecommended: {
    id: 'hubs.admissions.recommended-courses.columnYearsRecommended',
    defaultMessage: `Years Recommended`,
  },
});

export default messages;
